// opervex-frontend/src/Opervex/System/User.js

class User {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/System/Users/", data);
  }

  async update(id, data) {
    return this.#_api.put("/System/Users/" + id, data);
  }

  async findId(id) {
    return this.#_api.get("/System/Users/" + id);
  }

  async findAll() {
    return this.#_api.get("/System/Users");
  }

  async newPassword(username) {
    return this.#_api.post(`/System/Users/${username}/NewPassword`);
  }

  async updatePassword(id, data) {
    return this.#_api.put(`/System/Users/${id}/Password`, data);
  }

  async forgotPassword(username) {
    return this.#_api.post(`/System/Users/ForgotPassword/${username}`);
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "username",
        label: "Usuário",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "fullName",
        label: "Nome Completo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default User;
